module.exports = "/lucky-balls/img/jackpot/002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/002.png
// module id = 1102
// module chunks = 0